import { ROUTE_PATHS } from "../utilities/constants"

// KPI on an exercise (report, group dashboard, exercise row).
// Decided by the org that OWNS the exercise, not the viewer's org, and every KPI request from these
// surfaces names that org. data: show it. explain: a partner admin or platform admin sees why it's
// missing (the org has no KPI analytics). none: nothing (the org's own staff, players, trainers of
// another org — the server pins trainers to their own org).
export const KPI_VIEW = Object.freeze({ DATA: "data", EXPLAIN: "explain", NONE: "none" })

// orgRead false: the org couldn't be read (out of the viewer's scope, or the fetch failed). Then we
// don't know it lacks KPI, so nothing is explained (EXPLAIN only for an org actually read).
export const kpiViewFor = ({ manager = false, sponsor = false, trainer = false, crossOrg = false, kpi = false, orgRead = true }) => {
  const canView = manager || sponsor || (trainer && !crossOrg)
  if (!canView) return KPI_VIEW.NONE
  if (kpi) return KPI_VIEW.DATA
  if (!orgRead) return KPI_VIEW.NONE
  return manager || (sponsor && crossOrg) ? KPI_VIEW.EXPLAIN : KPI_VIEW.NONE
}

// Who may turn KPI analytics on for that org: a platform admin, or a partner admin managing it whose
// partner org may grant KPI_ANALYTICS (the same rule as the org edit dialog and the server).
export const canGrantKpiFor = ({ manager = false, permissions = [], viewerOrgId, viewerOrg, targetOrg }) =>
  manager ||
  (permissions.includes("organizations:crud:managed") &&
    !!targetOrg?.managingOrgId &&
    targetOrg.managingOrgId === viewerOrgId &&
    viewerOrg?.partnerGrantableEntitlements?.KPI_ANALYTICS === true)

export const kpiGrantPath = (orgId) => `${ROUTE_PATHS.ORGANIZATIONS}/${encodeURIComponent(orgId)}?edit=1`
